module.exports = __webpack_public_path__ + "img/clothing-banner.8727aa80.png";